import "core-js/modules/es.array.concat.js";
import { apiBaseUrl } from "@/api/service";
export default {
  name: "FlowPool",
  data: function data() {
    return {
      flowPool: {
        1: "限制",
        2: "普通",
        3: "优质",
        4: "极佳"
      }
    };
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getFlowPoolText: function getFlowPoolText(type) {
      var _this$flowPool;
      return ((_this$flowPool = this.flowPool) === null || _this$flowPool === void 0 ? void 0 : _this$flowPool[type]) || "";
    },
    //跳转 post 详情
    toDetail: function toDetail(_ref) {
      var secure_token = _ref.secure_token,
        token = _ref.token;
      console.log('change', apiBaseUrl);
      var link = "".concat(apiBaseUrl, "/community/").concat(secure_token, "?id=").concat(token);
      window.open(link, "_blank");
    }
  }
};